module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.74139e3d.woff";